import React from 'react';
import { Button, Card } from 'antd';
import styles from './styles.module.css';
import classNames from 'classnames';
import { DraftOrder, Order } from 'services/hitchit/types/online-sales/Order';
import { Product } from 'services/hitchit/types/online-sales/Product';
import { TriggerCollapse } from '../TriggerCollapse';

export const TriggerComponent = ({
  trigger,
  selected,
  onChange,
}: {
  trigger: Order | DraftOrder | Product;
  selected?: boolean;
  onChange: () => void;
}): JSX.Element => {
  return (
    <Card
      style={{ textAlign: 'left' }}
      hoverable
      className={classNames(selected && styles.selected)}
    >
      <TriggerCollapse trigger={trigger} />
      {!selected && (
        <Button type="primary" onClick={() => onChange()} style={{ float: 'right' }}>
          {trigger.type !== 'product'
            ? 'Preview with this order'
            : 'Preview with this product variant'}
        </Button>
      )}
      {selected && (
        <Button disabled onClick={() => onChange()} style={{ float: 'right' }}>
          {trigger.type !== 'product'
            ? 'Selected order preview'
            : 'Selected product variant preview'}
        </Button>
      )}
    </Card>
  );
};
